import { fullCommonMessageClient } from '../../../messages/fullCommonMessageClient';
// constant directory has been migrated to thread-data, the remaining the this directory will be moved over soon
import { REFETCH_CONVERSATION_MESSAGE } from '../constants/asyncActionTypes';
import { createAsyncAction } from 'conversations-async-data/async-action/createAsyncAction';
import { buildCommonMessage } from 'conversations-message-history/common-message-format/operators/buildCommonMessage';
export const fetchCommonMessage = createAsyncAction({
  requestFn: fullCommonMessageClient,
  actionTypes: REFETCH_CONVERSATION_MESSAGE,
  toRecordFn: response => buildCommonMessage(response)
});